// app/javascript/controllers/popup_controller.js
import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["content"]
    static values = {breakpoint: String}
    static classes = ["change"]
    static outlets = ["portal"]

    // initialize läuft ganz am Anfang, noch vor connect() und vor outlets
    initialize() {
        this.boundResize = this.handleResize.bind(this)
        this.boundClose = this.close.bind(this)
        this.boundMenuClick = this.handleMenuClick.bind(this)
    }

    connect() {
        // 1. Platzhalter
        this.placeholder = document.createElement("div")
        this.placeholder.style.display = "none"

        // 2. Referenz auf Menü
        if (this.hasContentTarget) {
            this.menuElement = this.contentTarget
        } else {
            return
        }

        if (!this.hasChangeClass) {
            this.element.setAttribute("data-popup-change-class", "hidden")
        }

        // 3. Listener für Resize und Klicks innerhalb des Menüs
        window.addEventListener("resize", this.boundResize)
        this.menuElement.addEventListener("click", this.boundMenuClick)

        this.updateVisibilityState()
    }

    // Wird aufgerufen, sobald der Portal-Controller gefunden wurde
    portalOutletConnected(outlet, element) {
        // 1. Overlay Klick -> Schließen
        if (outlet.hasOverlayTarget) {
            outlet.overlayTarget.addEventListener("click", this.boundClose)
        }

        // 2. Close Button(s) im Portal -> Schließen
        // Das greift jetzt deinen neuen Button
        outlet.closeButtonTargets.forEach(btn => {
            btn.addEventListener("click", this.boundClose)
        })
    }

    // Aufräumen
    portalOutletDisconnected(outlet, element) {
        if (outlet.hasOverlayTarget) {
            outlet.overlayTarget.removeEventListener("click", this.boundClose)
        }

        outlet.closeButtonTargets.forEach(btn => {
            btn.removeEventListener("click", this.boundClose)
        })
    }

    disconnect() {
        window.removeEventListener("resize", this.boundResize)
        this.menuElement.removeEventListener("click", this.boundMenuClick)
        this.close()
    }

    // ... (toggle, open, close, handleResize, etc. bleiben unverändert) ...

    toggle(event) {
        if (event) event.preventDefault()
        if (this.isBreakpointActive()) return

        if (this.isOpen) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        if (this.isOpen) return
        if (!this.hasPortalOutlet) return

        this.menuElement.replaceWith(this.placeholder)
        this.portalOutlet.containerTarget.appendChild(this.menuElement)
        this.menuElement.classList.remove(this.changeClass)
        this.portalOutlet.show()
        document.body.style.overflow = "hidden"
        this.isOpen = true
    }

    close(event) {
        
        if (!this.isOpen) return

        if (this.hasPortalOutlet) this.portalOutlet.hide()

        this.placeholder.replaceWith(this.menuElement)

        if (!this.isBreakpointActive()) {
            this.menuElement.classList.add(this.changeClass)
        }

        document.body.style.overflow = ""
        this.isOpen = false
    }

    handleMenuClick(event) {
        const link = event.target.closest("a, button[data-close]")
        if (link) this.close()
    }

    handleResize() {
        this.updateVisibilityState()
        if (this.isOpen && this.isBreakpointActive()) {
            this.close()
            this.menuElement.classList.remove(this.changeClass)
        }
    }

    updateVisibilityState() {
        if (this.isOpen) return
        if (this.isBreakpointActive()) {
            this.menuElement.classList.remove(this.changeClass)
        } else {
            this.menuElement.classList.add(this.changeClass)
        }
    }

    isBreakpointActive() {
        if (!this.hasBreakpointValue) return false
        return window.matchMedia(this.breakpointValue).matches
    }
}